/**
 * @file: FeatureNotEnabledView.tsx
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { EmptyView } from '@euler/components/EmptyView';
import { kStoreFeatureNames } from '@euler/functions/entitlements/storeFeatureNames';
import { StoreFeature } from '@euler/model/enum';
import { memo } from 'react';

/** What a screen shows in place of a feature the store does not have. */
export const FeatureNotEnabledView = memo(
  ({ feature }: { feature: StoreFeature }) => (
    <EmptyView
      message={`当前门店尚未开通${kStoreFeatureNames[feature]}，如需开通请联系知车客服。`}
    />
  ),
);
